var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"mt-5",attrs:{"src":"https://arun-nd.github.io/unitygame/","width":"100%","height":"1000px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }